<template>
  <v-row dense>
    <v-col cols="12">
      <span class="caption font-weight-bold">Natureza</span>
      <div :class="`${textClass}`">
        {{ formData.NATUREZA | truncate(45) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    textClass: {
      type: String,
      default: '',
    },
  },
};
</script>
